'use client';

// Recovered from the IMAI v5 animation source; demo documents stay illustrative.
import * as React from 'react';
import { ShowcaseCopyContext, translateShowcaseNode } from '../translation';
import { ShowcaseIcon } from './scene-primitives';
import { referenceImages, Me } from './reference-brands';
export const Pe = {
  lisiere: {
    name: 'Oxblood',
    hex: '#6B2F2A',
  },
  orvieto: {
    name: 'Cognac',
    hex: '#8A4B2D',
  },
  aubrac: {
    name: 'Oxblood',
    hex: '#7A2E2A',
  },
  mercer: {
    name: 'Vale green',
    hex: '#3F4A3C',
  },
};
export function BlurSwap({ value: e, className: t = '' }) {
  const showcaseCopy = React.use(ShowcaseCopyContext);
  let [n, r] = React.useState({
      value: e,
      key: 0,
    }),
    [i, a] = React.useState(null);
  return (
    n.value !== e &&
      (a(n),
      r({
        value: e,
        key: n.key + 1,
      })),
    React.useEffect(() => {
      if (!i) return;
      let e = window.setTimeout(() => a(null), 180);
      return () => window.clearTimeout(e);
    }, [i]),
    (
      <span className={`swap ${t}`}>
        {translateShowcaseNode(
          showcaseCopy,
          i ? (
            <span key={`out-${i.key}`} className={'swap-out'} aria-hidden={!0}>
              {translateShowcaseNode(showcaseCopy, i.value)}
            </span>
          ) : null
        )}
        <span key={n.key} className={n.key > 0 ? 'swap-in' : ''}>
          {translateShowcaseNode(showcaseCopy, n.value)}
        </span>
      </span>
    )
  );
}
export const lt = [
  [1, 1200, 600, 1200, 100],
  [0.5, 1200, 2300, 1200, 1800],
  [0.917, 900, 680.4, 650, 247.4],
  [0.417, 1750, 2152.6, 1500, 1719.6],
  [0.833, 680.4, 900, 247.4, 650],
  [0.333, 2152.6, 1750, 1719.6, 1500],
  [0.75, 600, 1200, 100, 1200],
  [0.25, 2300, 1200, 1800, 1200],
  [0.667, 680.4, 1500, 247.4, 1750],
  [0.167, 2152.6, 650, 1719.6, 900],
  [0.583, 900, 1719.6, 650, 2152.6],
  [0.083, 1750, 247.4, 1500, 680.4],
];
export function ShowcaseSpinner({ className: e = 'size-4' }) {
  const showcaseCopy = React.use(ShowcaseCopyContext);
  return (
    <svg
      viewBox={'0 0 2400 2400'}
      aria-hidden={!0}
      className={`stroke-current ${e}`}
    >
      <g strokeWidth={'200'} strokeLinecap={'round'} fill={'none'}>
        {translateShowcaseNode(
          showcaseCopy,
          lt.map(([e, t, n, r, i]) => (
            <line key={`${t}-${n}`} opacity={e} x1={t} y1={n} x2={r} y2={i} />
          ))
        )}
        <animateTransform
          attributeName={'transform'}
          attributeType={'XML'}
          type={'rotate'}
          keyTimes={
            '0;0.08333;0.16667;0.25;0.33333;0.41667;0.5;0.58333;0.66667;0.75;0.83333;0.91667'
          }
          values={
            '0 1199 1199;30 1199 1199;60 1199 1199;90 1199 1199;120 1199 1199;150 1199 1199;180 1199 1199;210 1199 1199;240 1199 1199;270 1199 1199;300 1199 1199;330 1199 1199'
          }
          dur={'0.83333s'}
          begin={'0.08333s'}
          repeatCount={'indefinite'}
          calcMode={'discrete'}
        />
      </g>
    </svg>
  );
}
export function CompletionMark({ done: e, className: t = 'size-4' }) {
  return e ? (
    <svg
      viewBox={'0 0 20 20'}
      fill={'none'}
      strokeLinecap={'round'}
      strokeLinejoin={'round'}
      aria-hidden={!0}
      className={t}
    >
      <circle
        cx={'10'}
        cy={'10'}
        r={'8'}
        stroke={'var(--border)'}
        strokeWidth={'1.5'}
      />
      <g className={'draw-now'} stroke={'currentColor'} strokeWidth={'1.5'}>
        <circle
          cx={'10'}
          cy={'10'}
          r={'8'}
          pathLength={1}
          transform={'rotate(-90 10 10)'}
        />
        <path
          d={'m6.6 10.3 2.3 2.3 4.5-4.8'}
          pathLength={1}
          style={{
            '--d': '300ms',
          }}
        />
      </g>
    </svg>
  ) : (
    <ShowcaseSpinner className={`text-ink-3 ${t}`} />
  );
}
export function ProgressRing({ value: e, on: t, className: n = 'size-4' }) {
  return (
    <svg viewBox={'0 0 20 20'} fill={'none'} aria-hidden={!0} className={n}>
      <circle
        cx={'10'}
        cy={'10'}
        r={'8'}
        stroke={'var(--border)'}
        strokeWidth={'1.5'}
      />
      <circle
        cx={'10'}
        cy={'10'}
        r={'8'}
        pathLength={1}
        stroke={'currentColor'}
        strokeWidth={'1.5'}
        strokeLinecap={'round'}
        strokeDasharray={'1 2'}
        strokeDashoffset={t ? 1 - e : 1}
        transform={'rotate(-90 10 10)'}
        className={'ring-fill'}
      />
    </svg>
  );
}
export function SegmentedControl({
  options: e,
  value: t,
  onChange: n,
  label: r,
  timer: i,
  className: a = '',
  size: o = 'md',
}) {
  const showcaseCopy = React.use(ShowcaseCopyContext);
  let s = React.useRef(null),
    [c, l] = React.useState(null);
  React.useLayoutEffect(() => {
    let e = s.current;
    if (!e) return;
    let t = () => {
      let t = e.querySelector('[aria-pressed="true"]');
      t &&
        l({
          x: t.offsetLeft,
          w: t.offsetWidth,
        });
    };
    t();
    let n = new ResizeObserver(t);
    return (n.observe(e), () => n.disconnect());
  }, [t]);
  let u =
    o === 'sm' ? 'h-10 sm:h-9 max-sm:px-2.5 max-sm:text-[12.5px]' : 'h-10';
  return (
    <div
      ref={s}
      role={'group'}
      aria-label={translateShowcaseNode(showcaseCopy, r)}
      className={`relative inline-flex max-w-full items-center rounded-full bg-[var(--tint)] p-1 ${a}`}
    >
      <span
        aria-hidden={!0}
        className={
          'sf pointer-events-none absolute top-1 bottom-1 left-0 rounded-full transition-[transform,width] duration-300 ease-[var(--ease)]'
        }
        style={{
          width: c?.w ?? 0,
          transform: `translateX(${c?.x ?? 0}px)`,
          opacity: +!!c,
        }}
      >
        {translateShowcaseNode(
          showcaseCopy,
          i ? (
            <span
              className={
                'absolute inset-x-3 bottom-[3px] h-[2px] overflow-hidden rounded-full bg-[var(--tint-2)]'
              }
            >
              <span
                key={i.key}
                className={'bg-accent block h-full origin-left'}
                style={{
                  animation: `v5-progress ${i.ms}ms linear both`,
                  animationPlayState: i.running ? 'running' : 'paused',
                }}
                onAnimationEnd={i.onEnd}
              />
            </span>
          ) : null
        )}
      </span>
      {translateShowcaseNode(
        showcaseCopy,
        e.map((e) => {
          let r = e.value === t;
          return (
            <button
              key={e.value}
              type={'button'}
              aria-pressed={r}
              onClick={() => n(e.value)}
              className={`press relative z-[1] flex ${u} min-w-10 shrink-0 items-center justify-center gap-1.5 rounded-full px-3 text-[13px] font-medium whitespace-nowrap sm:px-4 ${r ? 'text-ink' : 'text-ink-3 hover:text-ink'}`}
            >
              {translateShowcaseNode(
                showcaseCopy,
                e.meta ? (
                  <span
                    className={'num text-ink-4 hidden text-[12px] sm:inline'}
                  >
                    {translateShowcaseNode(showcaseCopy, e.meta)}
                  </span>
                ) : null
              )}
              {translateShowcaseNode(showcaseCopy, e.label)}
            </button>
          );
        })
      )}
    </div>
  );
}
export function ArtifactStatus({
  icon: e,
  title: t,
  done: n,
  working: r,
  doneLabel: i,
  action: a,
}) {
  const showcaseCopy = React.use(ShowcaseCopyContext);
  return (
    <div
      className={
        'flex h-11 shrink-0 items-center gap-2 border-b border-[color-mix(in_oklch,var(--border)_45%,transparent)] px-3 sm:px-4'
      }
    >
      <ShowcaseIcon name={e} className={'text-ink-3 size-4 shrink-0'} />
      <p
        className={
          'text-ink min-w-0 truncate text-[13px] leading-5 font-medium'
        }
      >
        {translateShowcaseNode(showcaseCopy, t)}
      </p>
      <span className={'num text-ink-4 shrink-0 text-[12px]'}>
        {translateShowcaseNode(showcaseCopy, 'v1')}
      </span>
      <span className={'ml-auto flex shrink-0 items-center gap-2'}>
        <span
          aria-live={'polite'}
          className={
            'text-ink-3 flex h-7 items-center gap-1.5 text-[12px] leading-4'
          }
        >
          <CompletionMark key={String(n)} done={n} className={'size-3.5'} />
          <span className={'swap'}>
            {translateShowcaseNode(
              showcaseCopy,
              n ? (
                <span key={'done'} className={'swap-in max-sm:sr-only'}>
                  {translateShowcaseNode(showcaseCopy, i)}
                </span>
              ) : (
                <span key={'busy'} className={'cf-shine'}>
                  {translateShowcaseNode(showcaseCopy, r)}
                </span>
              )
            )}
          </span>
        </span>
        {translateShowcaseNode(showcaseCopy, a)}
      </span>
    </div>
  );
}
export function IllustrativeBadge({ className: e = '' }) {
  const showcaseCopy = React.use(ShowcaseCopyContext);
  return (
    <span
      className={`text-ink-4 inline-flex h-5 items-center rounded-[6px] px-1.5 text-[11px] leading-4 shadow-[inset_0_0_0_1px_var(--line)] ${e}`}
    >
      {translateShowcaseNode(showcaseCopy, 'Illustrative')}
    </span>
  );
}
export const vs = referenceImages.lisiere.pieces;
export const ys = Me.lisiere;
export const bs = [
  {
    name: 'Ink',
    hex: ys[4] ?? '#1C1A17',
  },
  {
    name: 'Taupe',
    hex: ys[2] ?? '#8B7E6E',
  },
  {
    name: 'Chalk',
    hex: ys[0] ?? '#F2EEE6',
  },
  Pe.lisiere,
  {
    name: 'Umber',
    hex: ys[3] ?? '#3A342D',
  },
];
